export default {
	state: {
		versionNumber:	'6.0.77',
	},
}